import type { PropsWithChildren } from "react";

import { ErrorBoundary } from "../boundaries/ErrorBoundary.js";
import { AuthProvider } from "./AuthProvider.js";
import { QueryProvider } from "./QueryProvider.js";
import { ThemeProvider } from "./ThemeProvider.js";
import { ToastProvider } from "./ToastProvider.js";
import { AuthSheetHost } from "@/features/auth/AuthSheetHost.js";

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <AuthProvider>
          <ThemeProvider>
            <ToastProvider>
              {children}
              <AuthSheetHost />
            </ToastProvider>
          </ThemeProvider>
        </AuthProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
